import React from "react"
import BaseSvgIcon from "./Base"

const DownArrow = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <path
        transform="translate(6.000000, 5.000000)"
        d="M6,9.5c-0.1,0-0.3,0-0.4-0.1l-4-4c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0L6,8.3l3.6-3.6
          c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-4,4C6.3,9.5,6.1,9.5,6,9.5z"
      />
    </BaseSvgIcon>
  )
}

export default DownArrow
